import { useTranslation } from 'react-i18next';

export default function BenefitsSection() {
  const { t } = useTranslation();

  const benefits = [
    {
      icon: 'ri-file-list-3-line',
      title: t('benefit1Title'),
      text: t('benefit1Text'),
    },
    {
      icon: 'ri-exchange-line',
      title: t('benefit2Title'),
      text: t('benefit2Text'),
    },
    {
      icon: 'ri-book-open-line',
      title: t('benefit3Title'),
      text: t('benefit3Text'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('benefit4Title'),
      text: t('benefit4Text'),
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 text-center mb-12">
          {t('benefitsH2')}
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70 hover:border-primary-300/50 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 mb-4">
                <i className={`${benefit.icon} text-primary-600 text-xl`} style={{ width: 24, height: 24 }} />
              </div>
              <h3 className="font-semibold text-foreground-950 mb-2 text-base">
                {benefit.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {benefit.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}